import styled from "styled-components";
import { theme } from '../../../theme'
import { MdPriorityHigh } from "react-icons/md";
import { Button } from '../../../components/button'

const Item = styled.div`
  display: flex;
  align-items: center;
    padding: 1.9rem 3.7rem 1.9rem 1.2rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
    justify-content: space-between;
`

const ImageTextContainer = styled.div`
    display: flex;
    align-items: center;
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`


const TextContainer = styled.div`
    margin-left:1.9rem;
    .exam-title {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .exam-date {
        font-size: 1.2rem;
        color: #979797;
    }
`

const DeployedText = styled.div`
    text-transform: uppercase;
    text-align: center;
    font-weight: 700;
    font-size: 1rem;
    color: #979797;
`

const CreatedExamsItem = ({ isDeployed }) => {

    return (
        <Item>
            <ImageTextContainer>
                <ImageContainer>
                    <MdPriorityHigh />
                </ImageContainer>
                <TextContainer>
                    <p className="exam-title">Physics</p>
                    <p className="exam-date">JSS 1</p>
                </TextContainer>
            </ImageTextContainer>
            {
                isDeployed ?
                    (<DeployedText>
                        <span>DEPLOYED</span>
                    </DeployedText>)
                    :
                    (
                        // <Link to="/teacher/examination/create">
                        <Button style={{ width: '6rem', height: '2.5rem', fontSize: '1rem' }} variant="secondary">DEPLOY</Button>
                        // </Link>
                    )
            }
        </Item>
    )
}

export default CreatedExamsItem
